const CheckboxItem = ({
	checked,
	option,
	onClick,
	disabled,
}: {
	checked: boolean;
	option: {
		label: string;
	};
	onClick: () => void;
	disabled: boolean;
}) => {
	return (
		<div className={`item-renderer ${disabled && 'disabled'}`}>
			<input
				type="checkbox"
				onChange={onClick}
				checked={checked}
				tabIndex={-1}
				disabled={disabled}
			/>
			<div className="ml-3.5 text-gray-gray700 text-large font-interRegular">
				{option.label}
			</div>
		</div>
	);
};

export default CheckboxItem;
